import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

/**
 * Props for Passkey Auth Logout event.
 */
export type PasskeyAuthLogoutProps = EventProps

/**
 * @event passkey_auth_logout
 */
export const PasskeyAuthLogoutAnalytics = createAnalyticsStatic<PasskeyAuthLogoutProps>(
    ANALYTICS_EVENTS.PASSKEY.AUTH_LOGOUT,
)

export default PasskeyAuthLogoutAnalytics
